import React, { useCallback, useState, useEffect } from "react";
import ReactGA from "react-ga";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-grid-system";
import { Button } from "@blueprintjs/core";
import { useFormState } from "react-final-form";
import dayjs from "dayjs";

import { acceptEstimate } from "../actions";

import ThankYouScreen from "./ThankYouScreen";

function Survey({ quoteNumber, handleSubmit, loading, success }) {
  const [clickedButton, setClickedButton] = useState("");
  const { values } = useFormState();

  useEffect(() => {
    ReactGA.event({
      category: "Move Calculator",
      action: "Step",
      label: "Survey",
    });
  }, []);

  const {
    firstname,
    date_flexible,
    move_date,
    phone,
    billing_firstname,
    billing_lastname,
    billing_email,
    billing_phone,
    paymenttoken,
    address_1,
    city,
    state,
    pay_by,
    add_packing,
  } = values;

  const handleClick = useCallback(
    (surveymethod) => {
      setClickedButton(surveymethod);

      return handleSubmit(
        {
          billing_firstname,
          billing_lastname,
          billing_email,
          billing_phone,
          add_packing,
          paymenttoken,
          address_1,
          city,
          state,
          survey_method: surveymethod,
          next_step: surveymethod === "yembo" ? "book" : "talk",
          pay_by,
        },
        quoteNumber
      );
    },
    [values]
  );

  if (success) {
    return <ThankYouScreen surveyMethod={clickedButton} />;
  }
  return (
    <Container className="form-fields row">
      <Row>
        <div className="page-title">
          <h3>
            Thanks {firstname}. You’re almost set for your move{" "}
            {date_flexible && date_flexible.length ? "around" : "on"}{" "}
            {dayjs(move_date).format("MMM Do YYYY")}. A relocation expert will
            be in touch with you.
          </h3>
          <p>
            Based on how much stuff you actually have, your price may vary. In
            order to make sure we have everything right and have included all of
            your belongings, we&apos;ll need to complete a survey within 7 days
            of your move. This can be done a few different ways:
          </p>
        </div>
        <Col sm={12}>
          <div className="card">
            <div className="card__col">
              <h4>Do a virtual survey using our app</h4>
              <p>
                You will be able to record your rooms and give us any notes
                about what you may be moving yourself or items that you may not
                be moving. Press the button on the right and we&apos;ll text you
                a link.
              </p>
            </div>
            <Button
              className="button"
              loading={loading && clickedButton === "yembo"}
              onClick={() => handleClick("yembo")}
            >
              Text to {phone}
            </Button>
          </div>
        </Col>
        {/* Calendly survey scheduling disabled at client request.
        <Col sm={12}>
          <div className="card">
            <div className="card__col">
              <h4>Complete a virtual or in person survey</h4>
              <p>
                We&apos;ll connect with you on Facetime, Google Duo or other
                camera sharing app to do a walk-through of your home. We want to
                make sure we have an accurate idea of how many items you are
                moving. After this call we&apos;ll be able to give you a final,
                binding quote for your move. Based on where you are located we
                may also be able to offer an in-person walkthrough.
              </p>
            </div>
            <Button
              className="button"
              loading={loading && clickedButton === "inperson"}
              onClick={() => handleClick("inperson")}
            >
              Request appointment
            </Button>
          </div>
        </Col>
        */}
        <Col sm={12}>
          <div className="card">
            <div className="card__col">
              <h4>I think I need help!</h4>
              <p>
                If you&apos;re not sure of the next steps or the process
                we&apos;ll be happy to talk through any questions you may have.
              </p>
            </div>
            <Button
              className="button"
              loading={loading && clickedButton === "phonecall"}
              onClick={() => handleClick("phonecall")}
            >
              Call me
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

Survey.propTypes = {
  quoteNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  success: PropTypes.bool,
};

Survey.defaultProps = {
  loading: false,
  success: false,
};

const mapStateToProps = (state) => ({
  quoteNumber: state.estimate.id,
  loading: state.estimate.loading,
  success: state.estimate.success,
});

const mapDispatchToProps = (dispatch) => ({
  handleSubmit: (values, quoteNumber) =>
    dispatch(acceptEstimate(values, quoteNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Survey);
